import React from 'react';
import styles from './Badges.module.css';
import award from '../../../Assets/award.svg';
const Badges = ({ badges }) => {
  const levels = [
    'Foundation',
    '3D NFT Creator',
    '3D Environment Creator',
    'XR Interaction Creator',
    'Simulation Creator',
    'Ajna Creator',
  ];
  if (!badges) {
    return <></>;
  }
  return (
    <div className={styles.badges}>
      <div style={{ marginRight: '4px' }}>
        <img src={award} alt='' />
      </div>
      <div className={styles.badge}>{levels[badges]}</div>
    </div>
  );
};
export default Badges;
